goog.provide('el8.apphome.scheduler.renderer');

goog.require('el8.apphome.scheduler.util');
goog.require('el8.service.tz');
goog.require('el8.util.consts');
goog.require('el8.util.datecompare');

/**
 * Manages logic about how to convert the raw data format from the server into the data that the
 * templates expect. Appts are assumed to be sorted by appt time when passed in.
 *
 * A "slot" is an TzTime object which are used to organize appts.
 */
el8.apphome.scheduler.renderer.day = function(_date, appts, displayInterval, opts) {

    opts = opts || {};
    this._MIN_TIME = opts.minTime || el8.service.tz.newTzTime(0, 0, 0);
    this._MAX_TIME = opts.maxTime || el8.service.tz.newTzTime(23, 59, 59);
    this._INTERVAL = displayInterval; // in minutes
    var that = this;

    /** Assume appts are sorted by apptTime **/

    /** Create slots (useful for slotting appts) **/
    var slotTimeObjs = el8.apphome.scheduler.renderer.createSlotTimes(this._INTERVAL, this._MIN_TIME, this._MAX_TIME);
    // Array of TzTime objects for all intervals
    var _Slots = slotTimeObjs['slots'];
    // Object indexed by HHMM of the above with 'begin' and 'ongoing' arrays for appts
    var _SlotsByTime = slotTimeObjs['slotsByTime'];

    /** 
     * Pop appointments into slots 
     * - assume appts are sorted by apptTime
     */
    function _popInSlots(appt) {
        // Get an array of the slots which overlap with this appt
        var relevantSlots = el8.apphome.scheduler.renderer.getRelevantSlotTimes(appt, _Slots);

        // For each relevant slot
        for (var i=0; i<relevantSlots.length; i++) {
            var timeStr = el8.apphome.scheduler.util.getTimeStrId(relevantSlots[i]);

            // If this is the first relevant slot
            if (i === 0) {

                // Create the next time slot given the interval, used to check isComplete below
                var nextTimeSlot = el8.service.tz.newTzTime(relevantSlots[i]);
                nextTimeSlot.addMinutes(that._INTERVAL);

                // Push an object into the slots-by-time index 'begin' array with:
                // - isExact: bool - does this appt's start and end time exacly line up with slot times or not?
                // - isAligned: bool - does this appt's start time align with the slot?
                // - isComplete: bool - does the appt both start and end within this one slot?
                // - the appt's soymap
                _SlotsByTime[timeStr]['begin'].push({
                    isExact: Boolean(_SlotsByTime[el8.apphome.scheduler.util.getTimeStrId(appt.getStartTime())]
                                  && _SlotsByTime[el8.apphome.scheduler.util.getTimeStrId(appt.getEndTime())]),
                    isAligned: el8.apphome.scheduler.util.getTimeStrId(appt.getStartTime()) === timeStr,
                    isComplete: (appt.getEndTime().getTime() <= nextTimeSlot.getTime()),
                    appt: appt.asSoyMap()
                });
            } else {
                // If this appt continues to another slot push its soymap into the 'ongoing' array
                _SlotsByTime[timeStr]['ongoing'].push({
                    appt: appt.asSoyMap()
                });
            }
        }
    }

    // Run the _popInSlots fn above for all the appts which actually means to push the appt's
    // soymap into the _SlotsByTime index 'begin' and 'ongoing' arrays. The 'begin' array
    // also includes isExact and isComplete bools in the pushed object.
    for (var i=0; i<appts.length; i++) {
        _popInSlots(appts[i]);
    }

    // For each slot in the array, set its blockColor based on the color of the apptType
    // (if defined). If not defined, set a default gray. When there are multiple appts in
    // a block:
    // 1. Set the blockColor to the color of the one with the latest startTime
    // 2. In the case of a tie in startTimes, *** TBD ***
    var clean = [];

    var associateApptTypeColor = function (beginObj) {
        // associate the apptType color with the "beginObj" (otherwise will get the default gray)
        var appt = beginObj.appt;
        if (appt.apptType) {
            // noFetch since I might be in a print form which only has the apptTypes passed into
            // it and no ability/URL to query the server. This happens when a deleted appt type
            // exists and was breaking the print form. Will return null in that case. Will
            // set appts to default gray if their appt type is deleted
            var apptType = el8.data.apptTypes.getById(appt.apptType.id, true);

            if (apptType) {
                beginObj.color = apptType.getColor();
            }
        }
    };

    // Walk down the ordered array of slots
    for (var i=0; i<_Slots.length; i++) {
        var timeStr = el8.apphome.scheduler.util.getTimeStrId(_Slots[i]);
        var blockColor = el8.util.consts.SCHEDULER_BLOCK_COLOR;
        var isOverlapped = false;
        var isSameColorAsPrevious = false;
        var isEmpty = true;

        // If there was an appt that began in this slot
        if (_SlotsByTime[timeStr]['begin'].length) {
            isEmpty = false;

            // Appts that start in a slot have priority over any appt that is ongoing
            _.each(_SlotsByTime[timeStr]['begin'], associateApptTypeColor);

            // mark slot when begin-begin overlap exists
            if (_SlotsByTime[timeStr]['begin'].length > 1) { isOverlapped = true; }

            // if this isn't the first slot, look back to see if it's the same as the previous color
            if (i > 0) {
                var beginObj = _SlotsByTime[timeStr]['begin'][0];
                var lastColor = null;

                // check 'begin'
                if (clean[i-1]['begin'].length) {
                    lastColor = clean[i-1]['begin'][0]['color'];
                    if (lastColor === beginObj.color) {
                        isSameColorAsPrevious = true;
                    }
                }
                // check 'ongoing'
                if (clean[i-1]['ongoing'].length) {
                    lastColor = clean[i-1]['blockColor'];
                    if (lastColor === beginObj.color) {
                        isSameColorAsPrevious = true;
                    }
                }
            }

        } else if (_SlotsByTime[timeStr]['ongoing'].length) {
            isEmpty = false;

            // Color this slot based on the appt that started last and is still ongoing
            var firstBeginAppt = _.last(_SlotsByTime[timeStr]['ongoing']).appt;

            if (firstBeginAppt.apptType) {
                var apptType = el8.data.apptTypes.getById(firstBeginAppt.apptType.id, true);
                // If no color for this apptType, keep default blockColor
                if (apptType && apptType.getColor()) {
                    blockColor = apptType.getColor();
                }
            }

            // mark slot when ongoing-ongoing overlap exists
            if (_SlotsByTime[timeStr]['ongoing'].length > 1) { isOverlapped = true; }
        }

        // mark begin-ongoing overlap
        if (_SlotsByTime[timeStr]['begin'].length && _SlotsByTime[timeStr]['ongoing'].length) {
            isOverlapped = true;
        }

        clean.push({
            timeStrId: el8.apphome.scheduler.util.getTimeStrId(_Slots[i]),
            timeStr: _Slots[i].asTimeString(),
            begin: _SlotsByTime[timeStr]['begin'],
            ongoing: _SlotsByTime[timeStr]['ongoing'],
            block: isEmpty ? '' : 'middle',
            blockColor: blockColor,
            isSameColorAsPrevious: isSameColorAsPrevious,
            isOverlapped: isOverlapped
        });
    }

    return clean;
};

el8.apphome.scheduler.renderer.getRelevantSlotTimes = function(appt, slots) {
    var startTime = appt.getStartTime();
    var endTime = appt.getEndTime();
    var isRelevant = false;
    var result = [];
    for (var i=0; i<slots.length; i++) { 
        if (!isRelevant && (startTime.getTime() <= slots[i].getTime())) {
            if (i >= 1 && startTime.getTime() < slots[i].getTime()) {
                result.push(slots[i-1]);
            }
            isRelevant = true;
        }
        if (isRelevant) {
            if (endTime.getTime() <= slots[i].getTime()) {
                break;
            } else {
                result.push(slots[i]);
            }
        }
    }
    return result;
};

el8.apphome.scheduler.renderer.createSlotTimes = function(interval, minTime, maxTime) {

    minTime = minTime || el8.service.tz.newTzTime(0, 0, 0);
    maxTime = maxTime || el8.service.tz.newTzTime(23, 59, 59);

    var slots = [];
    var slotsByTime = {};
    var currTime = minTime;
    while (currTime.getTime() <= maxTime.getTime()) {
        slots.push(el8.service.tz.newTzTime(currTime.getHours(), currTime.getMinutes(), currTime.getSeconds()));
        slotsByTime[el8.apphome.scheduler.util.getTimeStrId(currTime)] = {
            'begin': [],
            'ongoing': []
        };
        currTime.addMinutes(interval);
    }
    return {
        slots: slots,
        slotsByTime: slotsByTime
    };
};

el8.apphome.scheduler.renderer.createTimes = function(interval, minTime, maxTime) {

    minTime = minTime || el8.service.tz.newTzTime(0, 0, 0);
    maxTime = maxTime || el8.service.tz.newTzTime(23, 59, 59);

    var timeStrs = [];
    var timeStrIds = [];

    var currTime = minTime;
    while (currTime.getTime() <= maxTime.getTime()) {
        timeStrs.push(currTime.asTimeString());
        timeStrIds.push(el8.apphome.scheduler.util.getTimeStrId(currTime));
        currTime.addMinutes(interval);
    }
    return {
        timeStrs: timeStrs,
        timeStrIds: timeStrIds
    };
};
